/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Link } from "react-router-dom";
import { landingPagesList } from "../../../../services/landingPagesList";
import _map from "lodash/map";

const LpLinksOverviewPage = () => {
  return (
    <div>
      {_map(landingPagesList, function (page, key) {
        return (
          <div key={key}>
            <Link to={page.url}>{page.keyword}</Link>
          </div>
        );
      })}
    </div>
  );
};

export default LpLinksOverviewPage;
